import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// import * as Cookies from 'js-cookie';
import cs from 'classnames';
import { bindActionCreators } from 'redux';

import { EVENTS } from 'shared/constants/gtmEvents';
// import Loader from 'shared/components/Loader/Loader';
import { setDataLayer } from 'shared/actions/globals';
import { withTranslate } from 'shared/hocs/withTranslate';
import { withFetch } from 'shared/hocs/withFetch';
import { enqueueNotification } from 'shared/actions/notifications';
import {
  calculateMonthlyPaymentV2,
  calculateExchange,
  // isAutoMoneyLeasing,
  isUlfLeasing,
  isUlf24Leasing,
  userFormValidation,
} from 'shared/helpers/leasing/utils';

import { getSymbolTitleBySlug } from 'shared/helpers/transportInfo';
import { getPrice } from 'shared/helpers/advert';
import { numberWithSpaces } from 'shared/helpers/common';
import { fireRTBEvent } from 'shared/helpers/rtbHouse';

// import FormInput from './Inputs/FormInput';
import {
  prepareParamsForLeasingLeadRequest,
  createAFinanceLeda,
  createAutoMoneyLead,
  createMyAutoLead,
} from 'shared/helpers/leasing/myAuto';

import { createUlfLead, getUlfParams } from 'shared/helpers/leasing/ulf';
import { createUlf24Lead } from 'shared/helpers/leasing/ulf24';

// import { monthlyHapaiCalculate, createHapaiLead } from 'shared/helpers/leasing/ulf24';

import UserDataForm from './UserDataForm/UserDataForm';
// import LeasingCalculateForm from './UserDataForm/LeasingCalculateForm';
// import UserDataFormExtended from './UserDataForm/UserDataFormExtended';
import UserDataFormWithPhotoDialogWrapper from './UserDataForm/UserDataFormWithPhotoDialogWrapper';

// eslint-disable-next-line css-modules/no-unused-class
import s from './LeasingOnlineBanner.css';

class LeasingWithCalculatorBanner extends React.Component {
  static propTypes = {
    modalMode: PropTypes.bool,
    advertInfo: PropTypes.shape().isRequired,
    setDataLayer: PropTypes.func.isRequired,
    onSubmited: PropTypes.func,
    eventPostfix: PropTypes.string,
    //
    user: PropTypes.shape(),
    leasingParams: PropTypes.shape(),
    fetch: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
    enqueueNotif: PropTypes.func.isRequired,
  };

  static defaultProps = {
    user: null,
    modalMode: true,
    leasingParams: null,
    onSubmited: () => {},
    eventPostfix: '',
  };

  constructor(props) {
    super(props);
    const { leasingParams, advertInfo, user } = this.props;
    const userName = (user && user.name) || '';
    const phone = (user && user.phones && user.phones[0].number) || '';
    const priceUah = getPrice(advertInfo.price, ['uah']);
    const prepaidUah = calculateExchange(advertInfo.price, leasingParams.prepaidSum, 'uah');
    const comission = calculateExchange(advertInfo.price, leasingParams.prepaidCommission, 'uah');
    const rate = leasingParams.annualRate;

    this.state = {
      price: priceUah,
      prepaid: prepaidUah,
      term: leasingParams.term,
      rate,
      comission,
      terms: [12, 24, 36, 48, 60, 72, 84],
      userName,
      birthday: '',
      phone,
      errorMessage: '',
      successMessage: '',
      // step: 'periods',
      step: 'userform',
      codeVerification: '',
      requestId: '',
      isLeasingApproved: false,

      disableBtnLeasing: false,
      disableBtnLeasingOnline: false,
      disableBtnCodeVerification: false,
      //
      loading: false,
    };
  }

  onLeadCreated = success => {
    this.pushEvent(`lead-create-${success ? 'success' : 'fail'}`);
  };

  onSubmitExtendedDataForm = () => {
    this.pushEvent('monthly-calculation-form-sumbit');
    this.setState({ step: 'userform' });
  };

  onSubmitUesrDataForm = e => {
    const { onSubmited, enqueueNotif, t, leasingParams } = this.props;
    e.preventDefault();
    const { phone, userName } = this.state;
    const errorMsg = userFormValidation({ phone, userName });

    if (errorMsg) {
      this.setState({ errorMessage: errorMsg });
      return;
    }

    this.fireEvent();
    this.setState({ disableBtnLeasing: true });
    let submit;

    // if (isAutoMoneyLeasing(leasingParams) && Cookies.get('leasing_partner') % 2) {
    //   submit = this.submitAutomoneyLeasingLead;
    // // } else if (isAutoMoneyLeasing(leasingParams)) {
    // //   submit = this.submitMyAutoLeasingLead;
    // } else
    if (isUlf24Leasing(leasingParams)) {
      submit = this.submitUlf24LeasingLead;
    } else if (isUlfLeasing(leasingParams)) {
      submit = this.submitUlfLeasingLead;
    } else {
      submit = this.submitAFinanceLeasingLead;
    }

    submit(isSUccess => {
      this.setState({ disableBtnLeasing: false });
      const errorMessage = !isSUccess
        ? 'Извините, произошла ошибка на сервере, попробуйте повторить операцию позже'
        : '';
      this.setState({
        userName: '',
        phone: '',
        errorMessage,
        successMessage: '',
      });
      if (isSUccess) {
        onSubmited();
        enqueueNotif(t('Ваша заявка отправлена!'));
        this.onLeadCreated(true);
      } else {
        this.onLeadCreated(false);
      }
    });
  };

  submitAFinanceLeasingLead = (cb, moreLeasingParams) => {
    const { phone, userName, term, prepaid, price } = this.state;
    const { advertInfo, leasingParams, fetch } = this.props;

    const prepaidPercent = prepaid * 100 / price;

    const leadsParams = prepareParamsForLeasingLeadRequest(
      { phone, userName },
      advertInfo,
      leasingParams,
      { term, prepaid: prepaidPercent },
      moreLeasingParams,
    );

    createAFinanceLeda(leadsParams, advertInfo, fetch)
      .then(data => cb(!!data))
      .catch(() => cb(false));

    return false;
  };

  submitMyAutoLeasingLead = (cb, moreLeasingParams) => {
    const { phone, userName, term, prepaid, price } = this.state;
    const { advertInfo, leasingParams, fetch } = this.props;

    const prepaidPercent = prepaid * 100 / price;

    const leadsParams = prepareParamsForLeasingLeadRequest(
      { phone, userName },
      advertInfo,
      leasingParams,
      { term, prepaid: prepaidPercent },
      moreLeasingParams,
    );

    createMyAutoLead(leadsParams, advertInfo, fetch)
      .then(data => cb(!!data))
      .catch(() => cb(false));

    return false;
  };

  submitAutomoneyLeasingLead = (cb, moreLeasingParams) => {
    const { phone, userName, term, prepaid, price } = this.state;
    const { advertInfo, leasingParams, fetch } = this.props;

    const prepaidPercent = prepaid * 100 / price;
    // TODO: sould be refactord for AutomoneyLeasingLead
    const leadsParams = prepareParamsForLeasingLeadRequest(
      { phone, userName },
      advertInfo,
      leasingParams,
      { term, prepaid: prepaidPercent },
      moreLeasingParams,
    );
    console.log('Creat Automoney Lead');
    createAutoMoneyLead(leadsParams, advertInfo, fetch)
      .then(data => cb(!!data))
      .catch(() => cb(false));

    return false;
  };

  submitUlfLeasingLead = cb => {
    const { phone, userName } = this.state;
    const { advertInfo, leasingParams, fetch } = this.props;

    const leadParams = getUlfParams({
      phone,
      userName,
      leasingParams,
      advert: advertInfo,
    });

    console.log('Create Ulf Lead');
    createUlfLead(leadParams, fetch).then(data => cb(!!data)).catch(e => {
      console.error(e);
      cb(false);
    });

    return false;
  };

  submitUlf24LeasingLead = cb => {
    const { phone, userName } = this.state;
    const { advertInfo, leasingParams, fetch } = this.props;

    const leadParams = getUlfParams({
      phone,
      userName,
      leasingParams,
      advert: advertInfo,
    });

    console.log('Create Ulf 24 Lead');
    createUlf24Lead(leadParams, fetch).then(data => cb(!!data)).catch(e => {
      console.error(e);
      cb(false);
    });

    return false;
  };

  // submitHapaiLeasingLead = cb => {
  //   const { phone, userName, term, prepaid, price } = this.state;
  //   const { advertInfo, leasingParams, fetch } = this.props;

  //   const leadParams = {
  //     phone,
  //     userName,
  //     advert: advertInfo,
  //     leasingParams,
  //     term,
  //     prepaid,
  //     price,
  //     userStorageId: localStorage.getItem('applensDeviceId') || '',
  //   };
  //   console.log('Create Hapai Lead');
  //   createHapaiLead(leadParams, fetch)
  //     .then(data => cb(data && data.success))
  //     .catch(() => cb(false));

  //   return false;
  // };

  fireEvent() {
    fireRTBEvent('leasingOld', {
      value: this.props.advertInfo.price && getPrice(this.props.advertInfo.price),
      ids: [this.props.advertInfo.id],
    });
    this.pushEvent('monthly-consultation-form-sumbit');
  }

  changeHandler = (field, value) => {
    this.setState({ [field]: value, errorMessage: '' });
  };

  pushEvent = eventName => {
    const { eventPostfix } = this.props;
    const partnert = ''; // isAutoMoneyLeasing(leasingParams) ? 'automoney-' : '';
    const event = `${partnert}${eventName}${eventPostfix ? `-${eventPostfix}` : ''}`;
    if (EVENTS.leasing[event]) this.props.setDataLayer(EVENTS.leasing[event]);
    else console.error(`Event: ${event} not found.`);
  };

  render() {
    const { t, advertInfo, leasingParams } = this.props;
    const { step, term, prepaid, price, rate, comission } = this.state;
    let monthlyPriceUah;

    // if (isHapaiLeasing(leasingParams)) {
    //   const prePaidPrecent = (prepaid - comission) * 100 / price * 0.01;
    //   monthlyPriceUah = monthlyHapaiCalculate(price, prePaidPrecent, term);
    // } else
    if (
      leasingParams &&
      leasingParams.extendedParams &&
      leasingParams.extendedParams.monthlyPaymentUAH
    ) {
      monthlyPriceUah = leasingParams.extendedParams.monthlyPaymentUAH;
    } else {
      monthlyPriceUah = calculateMonthlyPaymentV2({
        year: advertInfo.year,
        term,
        price,
        prepaid,
        rate,
        comission,
      });
    }

    const symbol = getSymbolTitleBySlug('uah');
    const monthlySum = numberWithSpaces(monthlyPriceUah);
    const titleHTML = `${t('Ежемесячный платеж')} <br /> <b>${monthlySum} ${symbol}</b>`;

    return (
      <div
        className={cs({
          [s.container]: true,
          [s.LeasingContainerContentSidebar]: !this.props.modalMode,
        })}
      >
        <UserDataFormWithPhotoDialogWrapper
          advertInfo={this.props.advertInfo}
          showTitle={!this.props.modalMode}
          titleHTML={titleHTML}
          showAgreemant={step === 'userform'}
        >
          <div className={s.LeasingMyAutoBanner}>
            {/* {step === 'periods' &&
              <LeasingCalculateForm
                leasingParams={leasingParams}
                advertInfo={this.props.advertInfo}
                price={price}
                prepaid={prepaid}
                term={term}
                terms={terms}
                changeHandler={this.changeHandler}
                onSubmitHandler={this.onSubmitExtendedDataForm}
              />}

            {step === 'userform' &&
              <UserDataFormExtended
                disableBtnLeasing={this.state.disableBtnLeasing}
                userName={this.state.userName}
                phone={this.state.phone}
                birthday={this.state.birthday}
                errorMessage={this.state.errorMessage}
                successMessage={this.state.successMessage}
                monthlyPayment={this.state.monthlyPayment}
                changeHandler={this.changeHandler}
                onSubmitHandler={this.onSubmitUesrDataForm}
                toggleLeasingModal={this.state.toggleLeasingModal}
              />} */}
            <UserDataForm
              disableBtnLeasing={this.state.disableBtnLeasing}
              userName={this.state.userName}
              phone={this.state.phone}
              birthday={this.state.birthday}
              errorMessage={this.state.errorMessage}
              successMessage={this.state.successMessage}
              monthlyPayment={this.state.monthlyPayment}
              changeHandler={this.changeHandler}
              onSubmitHandler={this.onSubmitUesrDataForm}
              toggleLeasingModal={this.state.toggleLeasingModal}
            />
          </div>
        </UserDataFormWithPhotoDialogWrapper>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  user: state.user && state.user.user,
});

const mapDispatchToProps = dispatch => ({
  enqueueNotif: bindActionCreators(enqueueNotification, dispatch),
  setDataLayer: bindActionCreators(setDataLayer, dispatch),
});

export default withStyles(s)(
  withFetch(
    withTranslate(connect(mapStateToProps, mapDispatchToProps)(LeasingWithCalculatorBanner)),
  ),
);



// WEBPACK FOOTER //
// ./src/shared/components/LeasingOnlineBanner/LeasingWithCalculatorBanner.js